import posthog, { isPostHogConfigured } from './posthog';

export const logPostHogWorkflow = (message, attributes) => {
  if (isPostHogConfigured) {
    posthog.logger.info(message, attributes);
  }
};
